<template>
  <event-page :event="event"></event-page>
</template>

<script>
import EventPage from '@/components/EventPage'
import {EventDoc} from '@/utils/types'

export default {
  components: {
    EventPage,
  },
  data: () => ({
    event: null,
  }),
  mounted() {
    EventDoc
      .get(this.eventId)
      .then((event) => {
        if (event.exists() && event.published) {
          this.event = event
        } else {
          this.$router.push({name: 'home'})
        }
      })
  },
  props: {
    eventId: String
  }
}
</script>
